import { UserOutlined } from '@ant-design/icons';
import { Avatar, Button, Card, Popconfirm, Popover, Spin, Tag, Typography } from 'antd';
import { findLevelsById } from 'api/services/levels/levels.services';
import { StatusCode } from 'common/enums';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import Delete from "../../../assets/images/app/delete_article.svg";
import MoreOptions from "../../../assets/images/app/options_icon.svg";
import backgroundImage from "../../../assets/images/teacher/card.svg";
import './StudentCard.css';

const { Text } = Typography;

interface StudentCardProps {
  data: any;
  onDelete?: (id: string) => void;
  isLoading?: boolean;
}

const StudentCard: React.FC<StudentCardProps> = ({ data, onDelete, isLoading }) => {

  const [visible, setVisible] = useState(false);
  const [visibleOptions, setVisibleOptions] = useState(false);

  const popoverReportRef = useRef<HTMLDivElement>(null);
  const [userLevel, setUserLevel] = useState<any>();

  const showPopconfirm = () => {
    setVisible(true);
    setVisibleOptions(false);
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const handleClickOutside = (event: MouseEvent) => {
    setTimeout(() => {
      if (popoverReportRef.current && !popoverReportRef.current.contains(event.target as Node)) {
        if (visible) {
          console.log("Action selected!");
        } else {
          setVisibleOptions(false);
        }
      }
    }, 200);
  };

  const content = (
    <div onClick={(e) => e.stopPropagation()}>
      <div onClick={showPopconfirm} style={{ fontSize: "1em", color: "#F56666" }}><img src={Delete} height={12} ></img> Supprimer</div>
    </div>
  );

  const getLevelById = useCallback(
    async (idLevel: any) => {
      try {
        if (idLevel) {
          const response = await findLevelsById(idLevel);
          if (response.statusCode === StatusCode.OK) {
            setUserLevel(response?.data['title']);
          }
        }
      } catch (error) { }
    },
    [userLevel]
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [visible]);

  useEffect(() => {
    if (data) {
      getLevelById(data?.student?.levelId);
    }
  }, [data]);

  useEffect(() => {
    if (!isLoading) {
      setVisible(false);
    }
  }, [isLoading]);

  return (
    <Card style={{ backgroundImage: `url(${backgroundImage})`, backgroundSize: "cover", backgroundPosition: "center" }} className="student-card">

      <div style={{ background: `${data?.studentInvitationStatus === "ACCEPTED" ? "#60CD95" : "#FFC8BA"}` }} className="ribbon">
        <span style={{ color: `${data?.studentInvitationStatus === "ACCEPTED" ? "#FFF" : "#F56666"}` }}>
          {data?.studentInvitationStatus === "ACCEPTED" ? "Ajouté" : "Ajouté"}
        </span>
      </div>

      <div className="student-content">
        <Avatar
          src={data?.student?.profile}
          icon={<UserOutlined />}
          className="student-avatar"
        />

        <Text strong className="student-name">
          {data?.student?.firstname + " " + data?.student?.lastname}
        </Text>

        <Tag className="grade-tag">
          {userLevel}
        </Tag>
      </div>

      <Popover
        visible={visibleOptions}
        placement="left"
        content={content}
        trigger="click"
        className="customPopoverStudent"
      >
        <div ref={popoverReportRef} className="optionButtonStudent" onClick={(e: any) => { e.stopPropagation(); setVisibleOptions(!visibleOptions); }}>
          <img src={MoreOptions} height={10} style={{ marginRight: "5px" }}></img>
          Options
        </div>
      </Popover>

      <Popconfirm
        placement="top"
        title={
          "Veux-tu vraiment supprimer cet élève ?"
        }
        onConfirm={() => onDelete?.(data?.student._id)}
        visible={visible}
        okText={isLoading ? <Spin size="small" /> : "Oui"}
        cancelText="Non"
        onCancel={handleCancel}
        okButtonProps={{ disabled: isLoading }}
      >
        <Button style={{ visibility: "hidden" }}></Button>
      </Popconfirm>
    </Card>
  );
};

export default StudentCard;
